import { selectResponseData } from 'util/selector/axiosSelector';

import { AxiosInstance } from 'axios';

import { CircleDto, CircleModel } from './dto/Circle.dto';

export class CircleApi {
  constructor(private client: AxiosInstance) {}

  fetch(): Promise<CircleModel[]> {
    return this.client.get<{ data: CircleDto[] }>(`/api/v1/circles`).then((response) => {
      const responseData = selectResponseData(response);
      return responseData.data;
    });
  }
}
